import { render, staticRenderFns } from "./profilePopup.vue?vue&type=template&id=b34be3cc&scoped=true"
import script from "./profilePopup.vue?vue&type=script&lang=js"
export * from "./profilePopup.vue?vue&type=script&lang=js"
import style0 from "./profilePopup.vue?vue&type=style&index=0&id=b34be3cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34be3cc",
  null
  
)

export default component.exports